import React from "react";
import {
  Container,
} from "@mui/material";
import Sidebar from "../user/sidebar";
import Deposit from './Deposit'
import Withdraw from './Withdraw'

const Account = () => {
  return (
    <Container maxWidth="xl" style={{ display: "flex" }}>
    <Sidebar />
      <div style={{ flex: "1", padding: "2rem", minHeight: "calc(100vh - 70px)" }}>
        <Deposit/>
        <Withdraw/>
      </div>        
    </Container>
  )
}

export default Account